/* === 商品説明の整形 === */
(function () {
  function formatDescription() {
    var descSelectors = [
      '.product__description',
      '.product__description-content',
      '.product-single__description',
      '.product__accordion__content',
      '.rte',
    ];
    var desc = null;
    for (var i = 0; i < descSelectors.length; i++) {
      desc = document.querySelector(descSelectors[i]);
      if (desc) break;
    }
    if (!desc) return;
    if (desc.dataset.formattedSdp) return;
    desc.dataset.formattedSdp = '1';

    // テーブルは保持してその他を整形
    var nodes = Array.from(desc.childNodes);
    var html = desc.innerHTML;
    // <table> は一旦退避
    var tableRe = /<table[\s\S]*?<\/table>/g;
    var tables = html.match(tableRe) || [];
    html = html.replace(tableRe, '___TABLE_PLACEHOLDER___');

    // テキストノードを変換
    // <br> や改行で行分割
    var lines = html.split(/<br\s*\/?>|\n/).map(function (l) {
      return l.replace(/<[^>]+>/g, '').trim();
    }).filter(function (l) { return l.length > 0; });

    var out = '<div class="sdp-desc">';
    lines.forEach(function (line) {
      // ― セクション ―
      var sec = line.match(/^[―—-]\s*(.+?)\s*[―—-]$/);
      if (sec) {
        out += '<h4 class="sdp-desc-section">' + escapeHtml(sec[1]) + '</h4>';
        return;
      }
      // ■見出し
      if (line.startsWith('■')) {
        out += '<h5 class="sdp-desc-heading">' + escapeHtml(line.substring(1).trim()) + '</h5>';
        return;
      }
      // key:value
      var kv = line.match(/^([^:：]{1,20})[:：]\s*(.+)$/);
      if (kv) {
        out += '<dl class="sdp-desc-kv"><dt>' + escapeHtml(kv[1].trim()) + '</dt><dd>' + escapeHtml(kv[2].trim()) + '</dd></dl>';
        return;
      }
      // 通常テキスト
      out += '<p class="sdp-desc-text">' + escapeHtml(line) + '</p>';
    });
    // テーブル復帰
    var tIdx = 0;
    out = out.replace(/___TABLE_PLACEHOLDER___/g, function () {
      return '<div class="sdp-desc-table">' + (tables[tIdx++] || '') + '</div>';
    });
    out += '</div>';
    desc.innerHTML = out;

    // 連続する .sdp-desc-kv を group で囲む（2列グリッド化のため）
    var kvs = desc.querySelectorAll('.sdp-desc-kv');
    var groups = [];
    var currentGroup = [];
    kvs.forEach(function (kv) {
      if (currentGroup.length === 0 ||
          currentGroup[currentGroup.length - 1].nextElementSibling === kv) {
        currentGroup.push(kv);
      } else {
        if (currentGroup.length > 0) groups.push(currentGroup);
        currentGroup = [kv];
      }
    });
    if (currentGroup.length > 0) groups.push(currentGroup);

    groups.forEach(function (grp) {
      if (grp.length < 2) return;
      var wrap = document.createElement('div');
      wrap.className = 'sdp-desc-kv-group';
      grp[0].parentNode.insertBefore(wrap, grp[0]);
      grp.forEach(function (item) { wrap.appendChild(item); });
    });

    // セクション直後の最初の要素は border-top を消す（重複線回避）
    desc.querySelectorAll('.sdp-desc-section').forEach(function (sec) {
      var next = sec.nextElementSibling;
      if (next && next.classList.contains('sdp-desc-kv-group')) {
        next.style.borderTop = 'none';
        next.style.marginTop = '0';
      }
    });
  }

  function escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatDescription);
  } else {
    formatDescription();
  }
  setTimeout(formatDescription, 1500);
})();

/* === ADD TO CART を通り過ぎたらヘッダーを表示 === */
(function () {
  function setupHeaderHide() {
    var header = document.querySelector('.site-header');
    var atc =
      document.querySelector('.product__submit__add') ||
      document.querySelector('[data-add-to-cart]');
    if (!header || !atc) return;

    header.classList.add('sdp-header-hideable');

    function checkScroll() {
      var atcRect = atc.getBoundingClientRect();
      // ADD TO CART の下端がビューポート上端より上に行ったら表示
      if (atcRect.bottom < 10) {
        header.classList.add('sdp-header-show');
      } else {
        header.classList.remove('sdp-header-show');
      }
    }

    window.addEventListener('scroll', checkScroll, { passive: true });
    window.addEventListener('resize', checkScroll, { passive: true });
    checkScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupHeaderHide);
  } else {
    setupHeaderHide();
  }
  // DOM 変化（価格移動など）後にも対応
  setTimeout(setupHeaderHide, 1000);
  setTimeout(setupHeaderHide, 3000);
})();

/* === モバイル：価格を QUANTITY と ADD TO CART の間に移動 === */
(function () {
  function movePriceMobile() {
    try {
      var isMobile = window.matchMedia('(max-width: 991px)').matches;

      // 価格ブロックを document 全体から検索（既に移動された後でもOK）
      var priceBlock =
        document.querySelector('.product__block.product__price-and-badge') ||
        document.querySelector('.product__price-and-badge') ||
        document.querySelector('.product__block .product__price-wrapper');
      if (!priceBlock || priceBlock.tagName === 'DIV' && priceBlock.classList.contains('product__price-wrapper')) {
        // 親 block を探す
        var p = document.querySelector('.product__price-wrapper');
        if (p) {
          priceBlock = p.closest('.product__block') || p;
        }
      }
      if (!priceBlock) return;

      // ADD TO CART のホルダーを探す
      var atcHolder =
        document.querySelector('.product__submit__holder') ||
        document.querySelector('.product__submit__buttons');
      if (!atcHolder) return;

      if (isMobile) {
        // 既に直前にいるならスキップ
        if (atcHolder.previousElementSibling === priceBlock) return;
        atcHolder.parentNode.insertBefore(priceBlock, atcHolder);
        priceBlock.classList.add('moved-mobile-before-atc');
      } else {
        // デスクトップ：moved 解除のみ
        if (priceBlock.classList.contains('moved-mobile-before-atc')) {
          priceBlock.classList.remove('moved-mobile-before-atc');
        }
      }
    } catch (e) {
      console.warn('[sdp] movePriceMobile error', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', movePriceMobile);
  } else {
    movePriceMobile();
  }
  window.addEventListener('resize', function () {
    clearTimeout(window._sdpPriceMobile);
    window._sdpPriceMobile = setTimeout(movePriceMobile, 200);
  });
  setTimeout(movePriceMobile, 400);
  setTimeout(movePriceMobile, 1200);
  setTimeout(movePriceMobile, 2500);
  setTimeout(movePriceMobile, 5000);
})();

/* === モバイル：breadcrumb / title をギャラリーの上に移動 === */
(function () {
  function moveTitleAboveGalleryMobile() {
    var isMobile = window.matchMedia('(max-width: 991px)').matches;
    var gallery = document.querySelector('.product-single__gallery');
    if (!gallery) return;
    var details = document.querySelector('.product-single__details');
    if (!details) return;

    var breadcrumb = document.querySelector('.breadcrumbs');
    var title = details.querySelector('.product__title') ||
                details.querySelector('h1.product__title') ||
                details.querySelector('.product-single__title');
    if (!breadcrumb && !title) return;

    if (isMobile) {
      // ギャラリーの直前に挿入（最初の1回のみ）
      if (breadcrumb && !breadcrumb.dataset.movedAbove) {
        gallery.parentNode.insertBefore(breadcrumb, gallery);
        breadcrumb.dataset.movedAbove = '1';
        breadcrumb.classList.add('moved-mobile-top');
      }
      if (title && !title.dataset.movedAbove) {
        // title が title-and-price block 内なら、block ごと移動
        var titleBlock = title.closest('.product__title-and-price');
        var blockToMove = titleBlock || title;
        gallery.parentNode.insertBefore(blockToMove, gallery);
        title.dataset.movedAbove = '1';
        blockToMove.classList.add('moved-mobile-top');
      }
    } else {
      // デスクトップ：元の位置に戻す（簡易、moved 解除のみ）
      document.querySelectorAll('.moved-mobile-top').forEach(function (el) {
        if (el.dataset.movedAbove) {
          details.insertBefore(el, details.firstChild);
          delete el.dataset.movedAbove;
          el.classList.remove('moved-mobile-top');
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveTitleAboveGalleryMobile);
  } else {
    moveTitleAboveGalleryMobile();
  }
  window.addEventListener('resize', function () {
    clearTimeout(window._sdpMobileResize);
    window._sdpMobileResize = setTimeout(moveTitleAboveGalleryMobile, 200);
  });
})();

/* === モバイル：カラー変更時の自動スクロールは無効化 ===
   画像高さ60vh制限で、画像と色選択が同画面に収まるため不要。
   スワイプによる誤動作を完全に防ぐため無効。
*/

/* === ウィッシュリストと評価エリアの間に余白を強制 === */
(function () {
  function fixWishlistMargin() {
    // Growave ウィッシュリストプレースホルダの親 block にマージン追加
    var placeholders = document.querySelectorAll('.gw-wl-add-to-wishlist-placeholder');
    placeholders.forEach(function (el) {
      var block = el.closest('.product__block') || el.closest('.standard__app') || el.parentElement;
      if (block) {
        block.style.marginBottom = '32px';
        block.style.paddingBottom = '8px';
        block.style.borderBottom = '1px solid #f0f0f0';
      }
    });

    // 評価ウィジェット placeholders の上にもマージン
    var reviewPlaceholders = document.querySelectorAll(
      '.gw-rev-average-reviews-widget, [class*="ReviewsStarRating"], [class*="AverageReviews"], .gw-widget-placeholder-LC, .gw-widget-placeholder-RC'
    );
    reviewPlaceholders.forEach(function (el) {
      var block = el.closest('.product__block') || el.parentElement;
      if (block && block !== document.body) {
        block.style.marginTop = '20px';
        block.style.paddingTop = '4px';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixWishlistMargin);
  } else {
    fixWishlistMargin();
  }
  // Growave 遅延描画に対応
  setTimeout(fixWishlistMargin, 500);
  setTimeout(fixWishlistMargin, 1500);
  setTimeout(fixWishlistMargin, 3000);
  setTimeout(fixWishlistMargin, 5000);
})();

/* === Shop Pay ボタンを DOM から削除 + ADD TO CART を全幅化 === */
(function () {
  function cleanupBuyButtons() {
    // Shop Pay 親 item を完全削除
    document.querySelectorAll('.product__submit__item[data-buy-it-now]').forEach(function (el) {
      el.remove();
    });
    document.querySelectorAll('[data-shopify="payment-button"]').forEach(function (el) {
      var parent = el.closest('.product__submit__item') || el.parentElement;
      if (parent) parent.remove();
    });
    document.querySelectorAll('shopify-accelerated-checkout').forEach(function (el) {
      var parent = el.closest('.product__submit__item') || el.parentElement;
      if (parent) parent.remove();
    });

    // ADD TO CART の親 item を全幅化
    document.querySelectorAll('.product__submit__buttons').forEach(function (container) {
      container.style.display = 'block';
      container.style.width = '100%';
      var firstItem = container.querySelector('.product__submit__item');
      if (firstItem) {
        firstItem.style.width = '100%';
        firstItem.style.display = 'block';
        firstItem.style.maxWidth = '100%';
        var btn = firstItem.querySelector('button, .product__submit__add');
        if (btn) {
          btn.style.width = '100%';
          btn.style.display = 'flex';
          btn.style.alignItems = 'center';
          btn.style.justifyContent = 'center';
          btn.style.gap = '8px';
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanupBuyButtons);
  } else {
    cleanupBuyButtons();
  }
  setTimeout(cleanupBuyButtons, 500);
  setTimeout(cleanupBuyButtons, 1500);
  setTimeout(cleanupBuyButtons, 3000);
})();

/* === Size Chart 自動挿入 ===
   商品説明内のサイズ表（<table>）を、サイズ選択の下に「Size Chart」ボタンとして配置。
*/
(function () {
  function init() {
    if (document.querySelector('.custom-size-chart-injected')) return;

    // 1. 説明文内の最初の table を探す
    var descSelectors = [
      '.product__description',
      '.product__description-content',
      '.product-single__description',
      '.product__accordion__content',
      '.rte',
    ];
    var table = null;
    for (var i = 0; i < descSelectors.length; i++) {
      var desc = document.querySelector(descSelectors[i]);
      if (desc) {
        var t = desc.querySelector('table');
        if (t) {
          table = t;
          break;
        }
      }
    }
    if (!table) return;

    // 2. サイズ選択 (option--button) を探す
    var sizeFieldset = null;
    var fieldsets = document.querySelectorAll('fieldset.radio__fieldset');
    fieldsets.forEach(function (fs) {
      var legend = fs.querySelector('legend');
      var label = legend ? legend.textContent.toLowerCase() : '';
      if (label.indexOf('size') >= 0 || label.indexOf('サイズ') >= 0) {
        // 画像付きでない（=サイズ用）radio_buttonがあるかでも確認
        if (!fs.querySelector('[data-variant-option-image]')) {
          sizeFieldset = fs;
        }
      }
    });
    if (!sizeFieldset) return;

    // 3. クローン挿入
    var cloned = table.cloneNode(true);
    var wrap = document.createElement('div');
    wrap.className = 'custom-size-chart-injected';
    wrap.innerHTML =
      '<details class="size-chart-details">' +
      '<summary class="size-chart-summary">📏 サイズ表を確認する</summary>' +
      '<div class="size-chart-body"></div>' +
      '</details>';
    wrap.querySelector('.size-chart-body').appendChild(cloned);

    // サイズ選択直後 (兄弟 selector-wrapper の直後) に挿入
    var parent = sizeFieldset.parentElement;
    if (parent && parent.parentElement) {
      parent.parentElement.insertBefore(wrap, parent.nextSibling);
    } else {
      sizeFieldset.parentElement.appendChild(wrap);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // variant 更新時にも再試行
  document.addEventListener('variant:change', init);
  setTimeout(init, 1500);
})();
